import React from 'react';

import { useEffect, useState } from 'react';
import ProfileDetailCard from './ProfileDetailsComp/ProfileDetailCard';
import RandomUserProfile from './ProfileDetailsComp/RandomUserProfile';
import Footer from './DashSubComponents/Footer';
import ShareHeader from '../Layout/ShareHeader';
import { Link, useParams } from 'react-router-dom'
import { Helmet } from "react-helmet";
import axios from 'axios'
import { BASE_URL } from '../Utils/BaseUrl';


const ProfileSharePage = () => {
    const [hide, setHide] = useState(false)
    const [prodata, setProData] = useState([])
    const [html , htmldata] = useState("")
    const { userid } = useParams()

    console.log(userid);
    async function userdetailsget() {
        const data = {
            user_id: userid,
        };

        // console.log(data);
        axios
            .post(`${BASE_URL}/user_detail_get`, data)
            .then((res) => {
                setProData(res.data[0]);

                const slug = res.data && res.data[0] && res.data[0].slug;

                window.location.href = `https://thetalentclub.co.in/p/user/${slug}`;
            })
            .catch((err) => {
                console.log(err);
            });
    }

    async function getUserDetails() {
        axios.get(`${BASE_URL}/profileshare/${userid}`)
            .then((res) => {
                htmldata(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    }

    useEffect(() => {
        userdetailsget();
        // getUserDetails();
    }, []);




    return (
        <>
            {/* <ShareHeader />

            <Helmet>
                <meta property="og:title" content={`${prodata.firstname} ${prodata.lastname} - The Talent Club`} />
                <meta property="og:site_name" content="webapp.thetalentclub.co.in" />
                <meta property="og:url" content={`https://webapp.thetalentclub.co.in/profileshare/${prodata.id}`} />
                <meta property="og:description" content={prodata.designation} />
                <meta property="og:type" content="website" />
                <meta property="og:image" itemprop="image" content={`https://thetalentclub.co.in/upload/profile/${prodata.profile_image}`}></meta>
            </Helmet>


           <div>{html}</div>
            <main className={hide ? "overlay" : ""} >
                <div className="main-section">
                    <div className="container">
                        <div className="main-section-data">
                            <div className="row">

                                <div className="col-lg-3 col-md-4 pd-left-none no-pd " id='left-section'>

                                    <div className="main-left-sidebar no-margin">
                                        <RandomUserProfile />



                                    </div>
                                </div>


                                <div className="col-lg-6 col-md-8 no-pd " id='mid-section'>
                                    <div className="main-ws-sec">

                                        <ProfileDetailCard />

                                    </div>
                                </div>


                                <div className="col-lg-3 pd-right-none no-pd " id='right-section'>
                                    <div className="right-sidebar">
                                  

                                        <Footer />



                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main> */}

        </>
    )
}

export default ProfileSharePage;